import React, { useEffect, useState } from 'react';
import { X, Save } from 'lucide-react';
interface AttributeEditModalProps {
  isOpen: boolean;
  onClose: () => void;
  attribute: string;
  onSave: (attribute: string) => void;
  isNew?: boolean;
}
const AttributeEditModal: React.FC<AttributeEditModalProps> = ({
  isOpen,
  onClose,
  attribute,
  onSave,
  isNew = false
}) => {
  const [editedAttribute, setEditedAttribute] = useState('');
  const [error, setError] = useState('');
  // Update local state when attribute prop changes
  useEffect(() => {
    if (isOpen) {
      setEditedAttribute(attribute || '');
    }
  }, [attribute, isOpen]);
  // Reset error when modal opens or closes
  useEffect(() => {
    setError('');
  }, [isOpen]);
  if (!isOpen) return null;
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setEditedAttribute(e.target.value);
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Validate field
    if (!editedAttribute.trim()) {
      setError('O nome do atributo é obrigatório');
      return;
    }
    // Save attribute
    onSave(editedAttribute.trim());
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" data-id="element-889">
      <div className="relative w-full max-w-md mx-auto bg-white rounded-lg shadow-lg p-6" data-id="element-890">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-500 hover:text-gray-700" data-id="element-891">
          <X size={20} data-id="element-892" />
        </button>
        <h3 className="text-xl font-semibold mb-4 text-gray-900" data-id="element-893">
          {isNew ? 'Adicionar atributo' : 'Editar atributo'}
        </h3>
        {error && <div className="mb-4 p-3 bg-red-50 text-red-700 rounded-md" data-id="element-894">
            {error}
          </div>}
        <form onSubmit={handleSubmit} className="space-y-4" data-id="element-895">
          <div data-id="element-896">
            <label className="block mb-1 text-sm font-medium text-gray-900" data-id="element-897">
              Nome do atributo
            </label>
            <input type="text" value={editedAttribute} onChange={handleChange} className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#1649ff] text-gray-900" placeholder="Ex: Inovação, Qualidade, Confiança" data-id="element-898" />
          </div>
          <div className="flex justify-end space-x-2 pt-2" data-id="element-899">
            <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 flex items-center" data-id="element-900">
              <X size={16} className="mr-2" data-id="element-901" />
              Cancelar
            </button>
            <button type="submit" className="px-4 py-2 bg-[#1649ff] text-white rounded-md hover:bg-blue-700 flex items-center" data-id="element-902">
              <Save size={16} className="mr-2" data-id="element-903" />
              Salvar
            </button>
          </div>
        </form>
      </div>
    </div>;
};
export default AttributeEditModal;